<a class="resetStyles container" [routerLink]="link ?? null" [attr.href]="link ? null : '#'">
    <article class="card-container">
        <section class="header">
            <h2 class="title">{{ cardData?.name }}</h2>
            <span class="icon" [innerHTML]="infoIcon" libTooltip [tooltip]="tooltipInfo"></span>
        </section>

        <section class="body">
            <ul class="list-main-info">
                @for (info of cardData?.mainInfo; track info.label) {
                    <li class="main-info">
                        <span class="label">{{ info.label }}:</span>
                        @if (info.link && info.value) {
                            <a
                                class="link-value"
                                [ngClass]="'info' + info.label.split(' ').join('')"
                                (click)="preventDefaultNavigation($event)"
                                [routerLink]="info.link"
                                [attr.href]="info.link ? null : '#'"
                            >
                                {{ info.value }}
                            </a>
                        } @else {
                            <span
                                class="value"
                                [title]="info.label === 'Address' ? info.value : ''"
                                [ngClass]="'info' + info.label.split(' ').join('')"
                                >{{ info.value || '-' }}
                            </span>
                        }
                    </li>
                }

                <li class="main-info">
                    <span class="label">Salesperson:</span>
                    @if (cardData?.salespersons?.length) {
                        <span class="value">
                            <app-user-info
                                [users]="$any($safeNavigationMigration(cardData?.salespersons))"
                            ></app-user-info>
                        </span>
                    } @else {
                        <span class="value">-</span>
                    }
                </li>
            </ul>
        </section>
    </article>
</a>
